import _defineProperty from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";
import _Promise from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/promise";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";

var _actions;

import * as types from "@/store/constants/types";
var actions = (_actions = {}, _defineProperty(_actions, types.ASYNC_GET_FUTURE_BABY_RESULT, function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(_ref, paload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            state = _ref.state, commit = _ref.commit, dispatch = _ref.dispatch;
            return _context2.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref3 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee(resolve, reject) {
                var filePath_one, filePath_two;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        try {
                          filePath_one = paload.filePath_one, filePath_two = paload.filePath_two;
                          dispatch(types.GET_FUTURE_BABY_RESULT_NEW, {
                            photo1: filePath_one,
                            photo2: filePath_two
                          }).then(function (result) {
                            var result_img = result && result.data && JSON.parse(result.data) && JSON.parse(result.data).data && JSON.parse(result.data).data.baby_photo_url;
                            commit(types.UPDATE_RESULT_BY_NAME, {
                              name: "futureBaby",
                              result: result_img
                            });
                          }).catch(function () {
                            console.log("ASYNC_GET_FUTURE_BABY_RESULT error");
                          });
                        } catch (e) {
                          reject(e);
                        }

                      case 1:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x3, _x4) {
                return _ref3.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.SYNC_GET_FUTURE_BABY_RESULT, function () {
  var _ref5 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee4(_ref4, paload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            state = _ref4.state, commit = _ref4.commit, dispatch = _ref4.dispatch;
            return _context4.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref6 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee3(resolve, reject) {
                var filePath_one, filePath_two, result, result_img;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.prev = 0;
                        filePath_one = paload.filePath_one, filePath_two = paload.filePath_two;
                        _context3.next = 4;
                        return dispatch(types.GET_FUTURE_BABY_RESULT_NEW, {
                          photo1: filePath_one,
                          photo2: filePath_two
                        });

                      case 4:
                        result = _context3.sent;
                        console.log("SYNC_GET_FUTURE_BABY_RESULT", result);
                        result_img = result && result.data && JSON.parse(result.data) && JSON.parse(result.data).data && JSON.parse(result.data).data.baby_photo_url;
                        commit(types.UPDATE_RESULT_BY_NAME, {
                          name: "futureBaby",
                          result: result_img
                        });
                        resolve(true);
                        _context3.next = 14;
                        break;

                      case 11:
                        _context3.prev = 11;
                        _context3.t0 = _context3["catch"](0);
                        reject(false);

                      case 14:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3, null, [[0, 11]]);
              }));

              return function (_x7, _x8) {
                return _ref6.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function (_x5, _x6) {
    return _ref5.apply(this, arguments);
  };
}()), _actions);
export default actions;